import { ModelRow } from "@mcleod/core";
import { AutogenLayoutEdiStatusCityQuickInfo } from "./autogen/AutogenLayoutEdiStatusCityQuickInfo";
import { CommonTooltips } from "@mcleod/common";
import { Component } from "@mcleod/components";

export class EdiStatusCityQuickInfo extends AutogenLayoutEdiStatusCityQuickInfo {

     /** This is an event handler for the onDataDisplay event of textboxStopDescription. */
    public static makeStatusCityCallBack(component: Component, row: ModelRow) {
        if( row!= undefined){
            if (row.get("status_code") === "X6" && component.field === "stop_description") {
                CommonTooltips.setTooltipContentLayout(component, new ModelRow("lme/datafusion/edistatus").setValues({
                    curr_stop_type:row.get("curr_stop_type"),
                    curr_loc_id: row.get("cons_loc_id"),
                    curr_loc_name:row.get("cons_loc_name"),
                    curr_address:row.get("cons_address"),
                    curr_city_name: row.get("cons_city_name"),
                    curr_state:row.get("cons_state"),
                    curr_zip_code: row.get("cons_zip_code"),
                    curr_contact_name: row.get("cons_contact_name_inbound"),
                    curr_phone: row.get("cons_phone_inbound"),
                    curr_latitude:row.get("cons_latitude_inbound"),
                    curr_longitude:row.get("cons_longitude_inbound"),
                    partner_stop_no:row.get("partner_stop_no"),
                    curr_plant:row.get("consignee_plant")
                }), "lme/datafusion/EdiStatusCityQuickInfo");
            } else {
                CommonTooltips.setTooltipContentLayout(component, new ModelRow("lme/datafusion/edistatus").setValues({
                    curr_stop_type:row.get("curr_stop_type"),
                    curr_loc_id: row.get("curr_loc_id"),
                    curr_loc_name:row.get("curr_loc_name"),
                    curr_address:row.get("curr_address"),
                    curr_city_name: row.get("curr_city_name"),
                    curr_state:row.get("curr_state"),
                    curr_zip_code: row.get("curr_zip_code"),
                    curr_contact_name: row.get("curr_contact_name"),
                    curr_phone: row.get("curr_phone"),
                    curr_latitude:row.get("curr_latitude"),
                    curr_longitude:row.get("curr_longitude"),
                    partner_stop_no:row.get("partner_stop_no"),
                    curr_plant:row.get("curr_plant")
                }), "lme/datafusion/EdiStatusCityQuickInfo");
            } 
        }
    }
}
